<template>
  <div>
    <div class="flex items-center space-x-4">
      <router-link :to="{ name: 'incomesIndex' }" class="system-button">
        <arrow-icon class="w-4 rotate-90"></arrow-icon>
      </router-link>
      <h2>{{ isEditing ? "Editar" : "Registrar" }} Venta</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form @submit.prevent="save">
        <section-header title="Datos de la Venta" />

        <div class="form-grid">
          <div class="form-field">
            <label for="amount">Monto</label>
            <input id="amount" type="number" step="any" v-model="form.amount" />
            <validation-errors :errors="errorFor('amount')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="income_category_id">Método de pago</label>
            <custom-select
              v-model="form.income_category_id"
              id="income_category_id"
              :options="[
                { value: null, label: 'Seleccionar' },
                { value: 1, label: 'Tarjeta' },
                { value: 2, label: 'Efectivo' },
              ]"
            />
            <validation-errors
              :errors="errorFor('income_category_id')"
            ></validation-errors>
          </div>

          <div class="form-field">
            <label for="date_time">Fecha (dejar vacía si es actual)</label>
            <input
              id="date_time"
              type="datetime-local"
              v-model="form.date_time"
            />
            <validation-errors
              :errors="errorFor('date_time')"
            ></validation-errors>
          </div>
        </div>

        <div
          class="flex flex-col w-full mt-4 relative"
          v-closable="closeDropdown"
        >
          <label for="client">Cliente (opcional)</label>
          <div class="flex w-full items-center">
            <p>{{ clientName }}</p>
            <button
              v-if="clientName"
              class="system-button"
              @click="
                clientName = '';
                form.client_id = null;
              "
            >
              <close-icon class="w-8 fill-current" />
            </button>
          </div>

          <custom-search
            v-if="!form.client_id"
            class="w-full sm:w-[500px]"
            placeholder="Buscar por nombre"
            v-model="searchText"
            @confirm="loadClients()"
            @clear="clients = null"
          />

          <table
            v-if="clients && clients.length > 0"
            class="table-auto text-sm mt-2 bg-white"
          >
            <thead class="text-left">
              <tr class="bg-gray-100">
                <th class="p-2 rounded-l-lg">ID</th>
                <th class="p-2">Nombre</th>
                <th class="p-2">Mascotas</th>
                <th class="p-2 rounded-r-lg">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="client in clients" :key="client.id">
                <td class="p-2">
                  {{ client.id }}
                </td>
                <td class="p-2">{{ client.name }} {{ client.last_name }}</td>
                <td class="p-2">
                  <div class="flex flex-wrap">
                    <div v-for="pet in client.pets" :key="pet.id" class="mr-4">
                      <router-link
                        :to="{
                          name: 'petsDetail',
                          params: { id: pet.id },
                        }"
                        class="underline"
                        >{{ pet.name }}</router-link
                      >
                    </div>
                  </div>
                </td>
                <td class="p-2">
                  <div class="flex">
                    <button
                      class="secondary-button"
                      @click.prevent="
                        clientName = client.name + ' ' + client.last_name;
                        form.client_id = client.id;
                        clients = null;
                      "
                    >
                      Seleccionar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-if="clients && clients.length === 0">
            No se encontraron resultados
          </p>

          <!-- <div
            v-if="isOpen"
            :class="[
              'absolute w-full z-10 rounded-b bg-white shadow max-h-72 overflow-y-auto top-full',
            ]"
          >
            <button
              v-for="client in clients"
              :key="client.id"
              @click.prevent="selectClient(client)"
              :class="[
                'text-left w-full block px-4 py-2 cursor-pointer hover:bg-primary-300 hover:bg-opacity-10 hover:text-primary-500 smooth z-50 bottom-full',
                {
                  'text-content-300': client.id !== form.client_id,
                },
                {
                  'bg-primary-300 bg-opacity-10 text-primary-500 smooth':
                    client.id === form.client_id,
                },
              ]"
            >
              {{ client.name + " " + client.last_name }}
            </button>
          </div> -->
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Registrar" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Income Form",

  data() {
    return {
      form: {
        income_category_id: null,
        amount: null,
        date_time: null,
        branch_id: null,
        client_id: null,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      clients: null,
      searchText: "",
      isOpen: false,
      clientName: "",
      paymentMethods: ["Tarjeta", "Efectivo"],
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "accounting");

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadIncome();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadIncome() {
      this.loading = true;

      try {
        let income = await api.incomes.getById(this.$route.params.id);
        this.clientName = income.client
          ? income.client.name + " " + income.client.last_name
          : "";
        income.date_time = income.date_time.replace(" ", "T").slice(0, 16);
        delete income.client;
        this.form = await JSON.parse(JSON.stringify(income));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async loadClients() {
      try {
        this.clients = await api.clients.getByBranch(
          this.$route.params.branchId,
          [
            {
              name: "all",
              value: true,
            },
            {
              name: "search",
              value: this.searchText,
            },
          ]
        );
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
      // if (this.isOpen) {
      //   this.positionDropdown();
      // }
    },

    closeDropdown() {
      this.isOpen = false;
      this.searchText = "";
    },

    handleInput(value) {
      this.loadClients();
      console.log(value.data);
    },

    selectClient(client) {
      this.form.client_id = client.id;
      this.clients = null;
      this.searchText = client.name + " " + client.last_name;
    },

    save() {
      this.form.branch_id = this.$route.params.branchId;

      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createIncome();
      } else {
        this.updateIncome();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.income_category_id) {
        this.errors["income_category_id"] = ["Campo requerido"];
      }

      if (!this.form.amount) {
        this.errors["amount"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createIncome() {
      this.loadingForm = true;

      try {
        const response = await api.incomes.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "incomesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateIncome() {
      this.loadingForm = true;

      try {
        const response = await api.incomes.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "incomesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>